import React from "react";
import { TextField, Box } from "@mui/material";
import { getFieldLabel } from "../../constants/Helpers";
import HelpText from "../HelpText/HelpText";

function NumTrapsHauled({ numTrapsHauled, handleChange }) {
  return (
    <Box m={0} width="100%" align="center">
      <h2 className="sectionTitle center">
        {getFieldLabel("effort", "numTrapsHauled")}
      </h2>
      <TextField
        name="numTrapsHauled"
        variant="standard"
        inputProps={{
          min: 1,
          style: { textAlign: "center" },
        }}
        size="small"
        type="number"
        value={numTrapsHauled}
        onChange={handleChange}
      />
      <HelpText
        helpText={getFieldLabel("effort", "numTrapsHauled", "helptext")}
      />
    </Box>
  );
}

export default NumTrapsHauled;
